import { useMutation, useQueryClient } from "@tanstack/react-query";
import { comgateCommentsKeys } from "Api/Queries/Merchants/useGetComgateCommentsQuery";
import { postMerchantsPublicIDOrbitLComgateComment } from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

type Parameters = {
  merchantPublicID: string;
  commentText: string;
};

type Props = {
  onSuccess?: () => void;
  onError?: () => void;
};

export const useSendComgateCommentMutation = ({
  onSuccess,
  onError,
}: Props = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: processResponseWithApiProblemDetails(
      ({ merchantPublicID, commentText }: Parameters) =>
        postMerchantsPublicIDOrbitLComgateComment(
          { commentText },
          merchantPublicID,
        ),
    ),
    onSuccess: (_data, { merchantPublicID }: Parameters) => {
      queryClient.invalidateQueries({
        queryKey: comgateCommentsKeys.byMerchantPublicId(merchantPublicID),
      });
      onSuccess?.();
    },
    onError,
  });
};
